import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Events } from 'ionic-angular';

@Component({
  selector: 'connection-status',
  templateUrl: 'connection-status.html'
})
export class ConnectionStatusComponent implements OnInit, OnDestroy {
  @Input() tone: 'card' | 'hero' = 'card';
  online = true;

  private onOnline = () => this.setOnline(true);
  private onOffline = () => this.setOnline(false);
  private onStatus = (status: string) => this.setOnline(status === 'ONLINE');

  constructor(private events: Events) {}

  ngOnInit() {
    this.online = typeof navigator === 'undefined' || navigator.onLine !== false;
    window.addEventListener('online', this.onOnline);
    window.addEventListener('offline', this.onOffline);
    this.events.subscribe('connectionStatus', this.onStatus);
  }

  ngOnDestroy() {
    window.removeEventListener('online', this.onOnline);
    window.removeEventListener('offline', this.onOffline);
    this.events.unsubscribe('connectionStatus', this.onStatus);
  }

  private setOnline(online: boolean) {
    this.online = online;
  }
}



// WEBPACK FOOTER //
// ./src/components/connection-status/connection-status.ts